import { BrandType } from "@/api-schema-enums";
import { renderBrandType } from "@/modules/masterdata/brand/_helpers/type-renderer";
import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getBrandTypeOptions(): { id: BrandType; name: string }[] {
  return Object.values(BrandType).map((type) => ({ id: type, name: renderBrandType(type) }));
}

/**
 * Filter for brand type
 * Uses the `type` field of the brand search body schema
 */
export class BrandTypeFilter extends Filter<{ type?: BrandType[] }, Record<string, never>> {
  readonly id: string = "type";
  readonly labelSingular = "masterdata:BrandType";
  readonly labelPlural = "masterdata:BrandType";
  readonly placeholder = "masterdata:SelectBrandType";
  readonly searchPlaceholder = "masterdata:SearchBrandType";
  readonly emptyText = "masterdata:NoBrandTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getBrandTypeOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
